import { TamanhosCartaz } from '@/components/atoms/Cartaz';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  ${({ theme }) => {
    return css`
      gap: ${theme.spacing[6]}px;
    `;
  }};
`;

export const ContainerListagemHorizontal = styled.div<{
  $tamanhoCartaz: TamanhosCartaz;
}>`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: ${({ theme, $tamanhoCartaz }) =>
    theme.tamanhoCartaz.width[$tamanhoCartaz]}px;
  gap: ${({ theme }) => theme.spacing[5]}px;
  align-items: stretch;
`;

export const ContainerScroll = styled.div`
  position: relative;
  width: 100%;
`;

export const ContainerButtonArrow = styled.div<{
  $position: 'direita' | 'esquerda';
  $paddingLeft: number;
}>`
  position: absolute;
  ${({ $position, $paddingLeft }) =>
    $position === 'esquerda'
      ? css`
          left: -${$paddingLeft / 2}px;
        `
      : css`
          right: -${$paddingLeft / 2}px;
        `}
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
`;
